import React, { useState } from 'react';

import CloseSVG from '../assets/CloseSVG.js';

import Button from '../Button';
import TriangleIcon from '../TriangleIcon/TriangleIcon';

const ActionPopup = ({ selected, handleCleanSelects, buttons }) => {
  const [isButtonsMobileShow, setIsButtonsMobileShow] = useState();

  return (
    <div className="action_popup">
      <div className="action_popup__panel">
        <Button type="button" className="action_popup__close" onClick={handleCleanSelects}>
          <CloseSVG />
        </Button>
        <div className="action_popup__counter">
          <span className="action_popup__count">{selected.length}</span>
          item(s) selected
        </div>
        <button
          type="button"
          onClick={() => setIsButtonsMobileShow(!isButtonsMobileShow)}
          className="action_popup__mobile-switcher"
        >
          <TriangleIcon direction={isButtonsMobileShow ? 'up' : 'down'} />
        </button>
      </div>
      <div className={`action_popup__buttons ${isButtonsMobileShow ? 'open' : ''}`}>
        {buttons.map((btn) => (
          <Button
            key={btn.title}
            type="button"
            className={`button_${btn.btnType} action_popup__button`}
            onClick={btn.fun}
          >
            {btn.svg}
            {btn.title}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default ActionPopup;
